import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Column, Spinner, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useRecentAgreements } from '../../../../hooks/useRecentAgreements';
import { SectionCard } from '../SectionCard/SectionCard';
import { AgreementItem } from './AgreementItem';
export const GetAgreementsOverviewCardTID = (parentTestId)=>getTestIds(parentTestId);
export function AgreementsOverviewCard(param) {
    let { customerId, customerName, onCreateProposal } = param;
    const { AgreementsOverviewCardTestIds: TID } = useMemo(()=>GetAgreementsOverviewCardTID(), []);
    const { t: agreementsTexts } = useLocaleKeys('pages.clientDetail.summary.agreementsOverview');
    const { rows, isLoading, isError, refetch, optimisticallyRemove } = useRecentAgreements(customerId);
    return /*#__PURE__*/ _jsx(SectionCard, {
        bi: {
            name: 'client_detail_agreements_overview_card'
        },
        testId: TID.Root(),
        title: agreementsTexts.title(),
        actions: /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'client_detail_create_proposal'
            },
            testId: TID.CreateProposalButton(),
            skin: "primary",
            underline: "none",
            onClick: onCreateProposal,
            children: agreementsTexts.createProposal()
        }),
        children: /*#__PURE__*/ _jsx(AgreementsOverviewBody, {
            tid: TID,
            texts: agreementsTexts,
            rows: rows,
            isLoading: isLoading,
            isError: isError,
            customerId: customerId,
            customerName: customerName,
            refetch: refetch,
            optimisticallyRemove: optimisticallyRemove
        })
    });
}
function AgreementsOverviewBody(param) {
    let { tid, texts, rows, isLoading, isError, customerId, customerName, refetch, optimisticallyRemove } = param;
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Spinner, {
            testId: tid.Loading(),
            size: 40
        });
    }
    if (isError && rows.length === 0) {
        return /*#__PURE__*/ _jsxs(Column, {
            gap: 12,
            alignItems: "start",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: tid.ErrorMessage(),
                    skin: "secondary",
                    children: texts.error.message()
                }),
                /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'client_detail_agreements_overview_retry'
                    },
                    testId: tid.ErrorRetry(),
                    skin: "primaryOutline",
                    onClick: refetch,
                    children: texts.error.retry()
                })
            ]
        });
    }
    if (rows.length === 0) {
        return /*#__PURE__*/ _jsx(Typography, {
            testId: tid.Empty(),
            skin: "secondary",
            children: texts.emptyMessage()
        });
    }
    return /*#__PURE__*/ _jsx(Column, {
        testId: tid.AgreementsList(),
        gap: 12,
        children: rows.map((row)=>/*#__PURE__*/ _jsx(AgreementItem, {
                row: row,
                customerId: customerId,
                customerName: customerName,
                refetch: refetch,
                optimisticallyRemove: optimisticallyRemove,
                testId: tid.AgreementRow(row.id)
            }, row.id))
    });
}
